<template>
    <div class="message-skeletons">
        <div class="message-skeleton" v-for="skeleton of skeletons" :key="skeleton">
            <a-skeleton active avatar :paragraph="{ rows: 4 }" style="z-index: 9" />
        </div>
    </div>
</template>
<script>
import { log2 } from "../../../utils/log2";
import ChatCloseSettingsButton from "./ChatCloseSettingsButton.vue";

const log = log2("ChatCloseSettingsButton");
export default {
    name: "MessageSkeleton",
    data: () => ({
        skeletons: [1, 2],
    }),
};
</script>
<style lang="scss" scoped>
.message-skeletons {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 30px;
    gap: 10px;

    .message-skeleton {
        display: flex;
        justify-content: flex-start;
    }
}
</style>
